const options = {
  5: "bg-slate-200/5",
  10: "bg-slate-200/10",
  25: "bg-slate-200/25",
  50: "bg-slate-200/50",
  75: "bg-slate-200/75",
  90: "bg-slate-200/90",
  100: "bg-slate-200",
};

const from = {
  5: "from-slate-200/5",
  10: "from-slate-200/10",
  25: "from-slate-200/25",
  50: "from-slate-200/50",
  75: "from-slate-200/75",
  90: "from-slate-200/90",
  100: "from-slate-200",
};

export default function getBackgroundSlate200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
